export const personSelector = state => state.person;
